import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable()
export class SPListService {
  public valFiltres = {};
  public currentPage = 0;
  public rowsPerPage: number = 20;
  public validFilters;
  public data: number = (new Date()).getFullYear();


  public getSearchValues(id) { return (this.valFiltres[id]?this.valFiltres[id]:""); }

  constructor() { }
}
